import types from "./types";

const initialState = {
  groupTrainersList:[],
  internalTrainersList: [],
  externalTrainersList: [],
  groupMembersList:[],
  groupWorkshopSubmit:{},
  groupWorkshopTimezone: [],
  updateWorkShop:{},
  updateWorkshopData: {},
  groupWorkshopData: {},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  console.log("actionsss",action.payload)
  switch (action.type) {
    case types.GET_TRAINERS_RESP:
      return {
        ...state,
        groupTrainersList: action.payload,
      };
    case types.GET_TRAINERS_CLEAR:
      return {
        ...state,
        groupTrainersList: [],
      };

    case types.GET_INTERNAL_TRAINERS_RESP:
      return {
        ...state,
        internalTrainersList: action.payload,
      };
    case types.GET_INTERNAL_TRAINERS_CLEAR:
      return {
        ...state,
        internalTrainersList: [],
      };

    case types.GET_EXTERNAL_TRAINERS_RESP:
      return {
        ...state,
        externalTrainersList: action.payload,
      };
    case types.GET_EXTERNAL_TRAINERS_CLEAR:
      return {
        ...state,
        externalTrainersList: [],
      };
      
      //GET MEMBERS REDUCER
      case types.GET_MEMBERS_RESP:
      return {
        ...state,
        groupMembersList: action.payload,
      };
    case types.GET_MEMBERS_CLEAR:
      return {
        ...state,
        groupMembersList: [],
      };

      case types.POST_WORKSHOP_RESPONSE:
      return {
        ...state,
        groupWorkshopSubmit: action.payload,
      };
    case types.POST_WORKSHOP_CLEAR:
      return {
        ...state,
        groupWorkshopSubmit: {},
      };

      case types.POST_WORKSHOP_TIMEZONE_RESPONSE:
        console.log("actionpayload",action.payload)
      return {

        ...state,
        groupWorkshopTimezone: action.payload,
      };
    case types.POST_WORKSHOP_TIMEZONE_CLEAR:
      return {
        ...state,
        groupWorkshopTimezone: [],
      };

      case types.UPDATE_WORKSHOP_RESPONSE:
        return {
          ...state,
          updateWorkShop: action.payload,
        };
      case types.UPDATE_WORKSHOP_RESPONSE_CLEAR:
        return {
          ...state,
          updateWorkShop: {},
        };

      case types.GET_WORKSHOP_DATA_RESPONSE:
        return {
          ...state,
          groupWorkshopData: action.payload,
        };
      case types.GET_WORKSHOP_DATA_CLEAR:
        return {
          ...state,
          groupWorkshopData: {},
        };
      case types.UPDATE_WORKSHOP_DATA_RESPONSE:
        return {
          ...state,
          updateWorkshopData: action.payload,
        };
      case types.UPDATE_WORKSHOP_DATA_CLEAR:
        return {
          ...state,
          updateWorkshopData: {},
        };
  
    default:
      return state;
  }
};